<template>
    <SettingsSection cssClass="account-api-settings">
        <template #title>
            <h2>{{ $t('views.account_settings.account_credits_title') }}</h2>
        </template>

        <template #content>
            <PpCreditsManager :card="true" />
        </template>
    </SettingsSection>
</template>

<script>
    import SettingsSection from '@/components/accountSettings/Section';
    import PpCreditsManager from '@/components/misc/PpCreditsManager';
    
    export default {
        name: 'AccountApiSettings',
        components: {
            SettingsSection,
            PpCreditsManager
        }
    }
</script>